// AFoodMealComponent.js
import { Col, InputNumber, Row, Typography, Space, Tag } from 'antd';
import { DollarOutlined, UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Add_Food_Reserve_Api, GetByRserveAndMeal_Food_Reserve_Api, Update_Food_Reserve_Api } from '../../API/FoodReserveApi';

const { Text } = Typography;

export const AFoodMealComponent = ({
    setLoading,
    showMessage,
    reserve,
    foodMeal,
    date_Shamsi,
    day,
    foodSectionTitle, // <<<<<<<<<<<< دریافت پراپرتی foodSectionTitle
    reportMode = false,
}) => {
    const [foodReserve, setFoodReserve] = useState(null);
    const [id, setId] = useState(0);
    const [currentFoodCount, setCurrentFoodCount] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        if (foodReserve) {
            setCurrentFoodCount(foodReserve.count);
            setTotalPrice(foodReserve.count * foodMeal.price);
        } else {
            setCurrentFoodCount(0);
            setTotalPrice(0);
        }
    }, [foodReserve, foodMeal.price]);

    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetByRserveAndMeal_Food_Reserve_Api({
                reserveId: reserve.id,
                foodMealId: foodMeal.id,
                date_Shamsi: date_Shamsi
            });
            setLoading(false);
            if (data.messageStatus === "Successful") {
                if (data.messageData.data) {
                    setFoodReserve(data.messageData.data);
                    setId(data.messageData.data.id);
                } else {
                    setFoodReserve(null);
                    setId(0);
                }
            } else if (data.messageStatus === "Failed" && data.message === "رکوردی یافت نشد") {
                setFoodReserve(null);
                setId(0);
            } //else {
              //  showMessage(data.message, "error");
            //}
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error");
        }
    }

    const handleInputChange = async (value) => {
        const sanitizedValue = value === null || value === undefined ? 0 : value;
        const maxUsers = reserve.reserve_Users?.length || 0;

        if (sanitizedValue > maxUsers) {
            showMessage(`تعداد "${foodMeal.foodTitle}" نمی‌تواند بیشتر از ${maxUsers}  باشد`, "error");
            return;
        }

        if (sanitizedValue === currentFoodCount) {
            return;
        }

        // setCurrentFoodCount(sanitizedValue);
        // setTotalPrice(sanitizedValue * foodMeal.price);

        setLoading(true);
        try {
            const apiData = {
                id: id || 0,
                foodMealId: foodMeal.id,
                foodTitle: foodMeal.foodTitle,
                reserveId: reserve.id,
                count: sanitizedValue,
                date_Shamsi: date_Shamsi,
            };

            let data;
            if (!id || id === 0) {
                if (sanitizedValue > 0) {
                    data = await Add_Food_Reserve_Api(apiData);
                    if (data.messageStatus === "Successful" && data.additional) {
                        setId(parseInt(data.additional));
                        setFoodReserve({ ...apiData, id: parseInt(data.additional) });
                    }
                } else {
                    setFoodReserve(null);
                    setId(0);
                    setLoading(false);
                    showMessage("رزرو لغو شد (تعداد صفر).", "Successful");
                    return;
                }
            } else {
                
                    data = await Update_Food_Reserve_Api(apiData);
                    if (data.messageStatus === "Successful") {
                        setFoodReserve({ ...apiData });
                    }
                //}
            }

            setLoading(false);

            if (data && data.messageStatus === "Successful") {
                showMessage(data.message, "Successful");

                setCurrentFoodCount(sanitizedValue);
                setTotalPrice(sanitizedValue * foodMeal.price);
                // if (sanitizedValue === 0 && (id !== 0 || (data && data.additional === "0"))) {
                //      setFoodReserve(null);
                //      setId(0);
                //}
            } else if (data) {
                showMessage(data.message, "error");
                loadData();
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error");
            loadData();
        }
    };

    const maxUsers = reserve.reserve_Users?.length || 0;
    const isFull = foodMeal.maxUsers !== undefined && (foodMeal.currentCount || 0) >= foodMeal.maxUsers;


    return (
        <div
            style={{
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                padding: '10px',
                margin: '10px 0',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            }}
        >
            <Space direction="vertical" size={2} style={{ flexGrow: 1 }}>
                <Text strong style={{ fontSize: '15px' }}>{foodMeal.foodTitle}</Text>
                <Space size={4}>
                       <Text type="secondary" style={{ fontSize: '13px' }}>
                        {foodMeal?.price?.toLocaleString('fa-IR')} ریال
                    </Text>
                </Space>
                {/* نمایش وضعیت ظرفیت */}
                {currentFoodCount !== undefined && maxUsers !== undefined && (
                    <Tag
                        icon={<UserOutlined />}
                        color={isFull ? 'error' : (currentFoodCount > 0 ? 'success' : 'processing')}
                        style={{ marginTop: '5px' }}
                    >
                        {currentFoodCount}/{maxUsers}
                    </Tag>
                )}
            </Space>

            <Space direction="vertical" align="end">
                {/* اطلاعات روز، تاریخ و وعده غذایی در اینجا قرار می‌گیرد */}
                {day && foodSectionTitle && (
                    <Space size={4} style={{ marginBottom: '4px' }}>
                        <Text type="secondary" style={{ fontSize: '11px' }}>
                            {foodSectionTitle} | {day.shamsiDay} {day.date_Shamsi}
                        </Text>
                        <ShoppingCartOutlined style={{ color: '#1890ff', fontSize: '16px' }} />
                    </Space>
                )}

                <InputNumber
                    min={0}
                    max={maxUsers}
                    style={{
                        width: 100,
                        borderRadius: '2px',
                        height: '32px'
                    }}
                    disabled={reportMode || (maxUsers === 0 && !currentFoodCount > 0) || (isFull && currentFoodCount === 0)}
                    onChange={handleInputChange}
                    value={currentFoodCount}
                />
                {totalPrice > 0 && (
                    <Text type="success" strong style={{ fontSize: '14px', marginTop: '5px' }}>
                         {totalPrice.toLocaleString('fa-IR')} ریال
                    </Text>
                )}
            </Space>
        </div>
    );
};